import React from 'react';

import { cnPrefooter } from 'client/common/components/prefooter';
import { useLegoComponents } from 'client/common/hooks';

interface IPrefooterItemProps {
    url: string;
    name: string;
}

function PrefooterItem({ url, name }: IPrefooterItemProps) {
    const { Link } = useLegoComponents();
    const listBlankLink = [
        '/adv/edu',
        '/adv/edu/events',
        '/adv/edu/online',
        '/adv/edu/materials'
    ];

    return (
        <div className={cnPrefooter('item')}>
            <Link target={listBlankLink.includes(url) ? '_blank' : '_self'} theme="black" href={url}>{name}</Link>
        </div>
    );
}

export default PrefooterItem;
